import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute } from '@angular/router';
import { FUNCTION_RESULT_STATUS } from '@nova/common-interfaces';
import { BlockUIModule } from 'ng-block-ui';
import { CommonReadOnlyService } from '../../services/common/common-readonly.service.mjs';
import { CommonComponent } from './common.component.mjs';

@Component({
    selector: 'app-common-data-component',
    standalone: true,
    template: ``,
    imports: [BlockUIModule, MatCardModule, MatButtonModule, MatMenuModule]
})
export abstract class CommonDataComponent<
  T,
  K,
  S extends CommonReadOnlyService<T, K>
> extends CommonComponent {
  // #region Properties (2)

  protected service: S | undefined;

  public objectData: T | undefined;

  // #endregion Properties (2)

  // #region Constructors (1)

  constructor(
    @Inject(CommonReadOnlyService) baseService: S,
    protected activatedRoute: ActivatedRoute
  ) {
    super();
    this.service = baseService;
  }

  // #endregion Constructors (1)

  // #region Public Methods (1)

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      const id = params['id'];
      this.refreshData(id);
    });
  }

  // #endregion Public Methods (1)

  // #region Protected Methods (1)

  protected refreshData(id: string) {
    this.isLoading(true);
    this.hasData = false;
    this.service!.get(id)
      .then((result) => {
        if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
          this.objectData = result.data;
          this.hasData = true;
        }
      })
      .catch((error) => {
        console.debug('Error', error);
      })
      .finally(() => {
        this.isLoading(false);
      });
  }

  // #endregion Protected Methods (1)
}
